module.exports = __webpack_public_path__ + "img/WPS图片66@2x.c694a84a.png";